<template>
  <footer>
    <div class="copyright d-flex justify-content-center align-items-center">
      <div>Copyright & web design by <a href="https://www.chanchao.com.tw/" target="_blank">CHAN CHAO</a></div>
    </div>
  </footer>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style lang="scss"></style>
